import React from 'react';
import { Box, Typography } from '@mui/material';
import { FactureFormaliteApiObject } from '@europrocurement/l2d-domain';
import { CollectionProvisionType } from '../../../hooks/useCollectionProvision';
import { CollectionReglementType } from '../../../hooks/useCollectionReglement';
import NoResult from '../NoResult/NoResult';
import LigneProvisionReglement from '../LigneProvisionReglement/LigneProvisionReglement';
import {
    ActionWidth,
    DateEnregistrementLibelle,
    DateEnregistrementWidth,
    FactureLieeLibelle,
    FactureLieeWidth,
    ModeLibelle,
    ModeWidth,
    MontantLibelle,
    MontantWidth,
    NoteLibelle,
    NoteWidth,
    ReferenceLibelle,
    ReferenceWidth,
    TransactionCBLibelle,
    TransactionCBWidth,
} from '../LigneProvisionReglement/functions';

export type CollectionProvisionProps = {
    acomptes: CollectionProvisionType[];
    reglements: CollectionReglementType[];
    afterSubmit: () => void;
    handleValidateInvoice: (invoice: FactureFormaliteApiObject) => Promise<void>;
};

const CollectionProvision: React.FunctionComponent<CollectionProvisionProps> = function (props) {
    const { acomptes, reglements, afterSubmit, handleValidateInvoice } = props;

    if (acomptes.length === 0 && reglements.length === 0) {
        return (
            <NoResult
                title="Aucun encaissement renseigné pour le moment"
                paddingSx="15px"
            />
        );
    }
    return (
        <Box
            sx={{
                padding: '10px',
            }}
        >
            <Box
                sx={{
                    display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'flex',
                        xl: 'flex',
                    },

                    flexDirection: 'row',
                    width: '100%',
                    padding: '4px 8px 4px 4px',
                    gap: '0',
                    alignItems: 'center',
                    color: 'text.gris50',
                }}
            >
                <Box
                    sx={{
                        width: ModeWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {ModeLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: MontantWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {MontantLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: NoteWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {NoteLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: ReferenceWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {ReferenceLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: DateEnregistrementWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {DateEnregistrementLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: TransactionCBWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {TransactionCBLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: FactureLieeWidth,
                    }}
                >
                    <Typography
                        variant="l2dtableCell"
                        sx={{
                            color: 'text.gris50',
                        }}
                    >
                        {FactureLieeLibelle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: ActionWidth,
                    }}
                />
            </Box>

            {acomptes.map((acompte) => (
                <LigneProvisionReglement
                    reglement={acompte}
                    afterSubmit={afterSubmit}
                    key={`acompte${acompte.id}`}
                    handleValidateInvoice={handleValidateInvoice}
                />
            ))}
            {reglements.map((reglement) => (
                <LigneProvisionReglement
                    reglement={reglement}
                    key={`reglement${reglement.id}`}
                    handleValidateInvoice={handleValidateInvoice}
                />
            ))}
        </Box>
    );
};

export default CollectionProvision;
